<template>
    <b-modal
            :visible="show"
            @hidden="hideEvents"
            @show="loadClientActions"
            title="Client Actions"
            :id="modalId"
            scrollable
            v-bind:hide-footer="isListShown"
            size="lg"
            @hide="hideModalSafely"
    >
        <template #modal-header>
            <div class="container">
                <h3 v-if="isListShown" class="mb-0">Client Actions</h3>
                <h3 v-if="isActionShown" class="mb-0">Client Action #{{ clientActionId }}</h3>
            </div>
            <button @click="hideModalSafely" type="button" aria-label="Close" class="close">×</button>
        </template>
        <ul v-if="isListShown" class="p-3" style="list-style-type: none; line-height: 1.1;">
            <li
                    v-for="clientAction in clientActions"
                    :key="clientAction.clientActionId"
                    class="mb-4 border clientActionList clientActionListItem"
                    v-bind:id="clientAction.clientActionId"
                    @click="openClientAction(clientAction.clientActionId)"
            >
                <div class="">
                    <div class="header">
                        <b-row class="text-left m-0 pt-2">
                            <b-col class="mb-2">
                                Client Action ID
                            </b-col>
                            <b-col class="mb-2">
                                Status
                            </b-col>
                            <b-col class="mb-2">
                                Due Date
                            </b-col>
                            <b-col class="mb-2">
                                Priority
                            </b-col>
                        </b-row>
                        <b-row class="text-left m-0 border-bottom" style="">
                            <b-col class="mb-2">
                                <span>#{{ clientAction.clientActionId }}</span>
                            </b-col>
                            <b-col class="mb-2">
                                <span>{{ clientAction.status }}</span>
                            </b-col>
                            <b-col class="mb-2">
                                <span>{{ clientAction.dueDate | formatDate }}</span>
                            </b-col>
                            <b-col class="mb-2">
                                <span>{{ clientAction.clientActionPriority }}</span>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="header">
                        <b-row class="text-left m-0 mt-2 pb-2 body" style="line-height: 1.3;">
                            <b-col colspan="4">
                                <div class="float-left">
                                    Assigned to:
                                    <span v-if="clientAction.team">{{ clientAction.team }} </span>
                                    <span v-if="clientAction.firstName">{{ clientAction.firstName }} ({{ clientAction.team }})</span><br>
                                    <span class="font-weight-light">{{ clientAction.description }}</span>
                                </div>
                                    <div
                                        class="ml-1 float-right border rounded-circle px-2 py-1 mt-2 listIcon icon">
                                        <font-awesome-icon
                                            :icon="['far', 'arrow-right']"
                                            size="sm"
                                        >
                                        </font-awesome-icon>
                                    </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </li>
        </ul>
        <div v-if="isActionShown" class="w-100">
            <client-action-item
                    v-if="clientActionId !== null"
                    :client-action-id="clientActionId"
                    :clientAction="clientAction"
                    flat
                    @close="hideModal"
            >
            </client-action-item>
        </div>
        <template #modal-footer v-if="isActionShown">
            <div class="w-100" >
                <button
                        @click="hideAction"
                        type="button"
                        class="btn btn-primary float-left"
                >
                    <font-awesome-icon
                            :icon="['far', 'arrow-left']"
                            size="lg"
                            class="ml-1"
                    >
                    </font-awesome-icon>
                    Back to Client Actions
                </button>
                <client-action-buttons
                        class="float-right"
                        :clientAction="clientAction"
                >
                </client-action-buttons>
            </div>
        </template>
    </b-modal>
</template>
<script>
import ModalMixin from '@/components/Modal/ModalMixin';
import ConfirmationWarning from '@/components/Notifications/ConfirmationWarning';
import Action from '../../../services/Action/Action';
import ClientActionModal from '@/components/Action/Modal/ClientActionModal';
import ClientActionItem from '@/components/Action/ClientAction';
import ClientAction from '@/services/Action/ClientAction';
import ClientActionButtons from '@/components/Action/ClientActionButtons';
import riskhub from "@/services/Riskhub/Riskhub";

export default {
  name: 'Client-Actions-List-Modal',
  components: {
    ClientActionItem,
    ConfirmationWarning,
    ClientActionModal,
    ClientActionButtons,
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'clientActionsListModal',
      title: 'Client Actions',
      loading: false,
      clientActions: [],
      clientAction: null,
      clientActionId: null,
      isActionShown: false,
      isListShown: true,
    };
  },
  props: {
    actionId: {
      default: null,
    },
  },
  filters: {
    formatDate(date) {
      return riskhub.formatDate(date) || 'N/A';
    },
  },
  methods: {
    hideModalSafely() {
      this.isActionShown = false;
      this.isListShown = true;
      this.hideModal();
    },
    openClientAction(clientActionId) {
      this.clientActionId = clientActionId;
      this.clientAction = this.fetchAction(clientActionId);
      this.show = true;
      this.isActionShown = true;
      this.isListShown = false;
    },
    async loadClientActions() {
      this.loading = true;
      this.loading = false;
      const { actionId } = this;
      try {
        const { data } = await Action.getLinkedClientActions({ actionId });
        this.clientActions = data.data;
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
    async fetchAction(id) {
      try {
        const response = await ClientAction.find(id);
        this.clientAction = response.data.data;
      } catch (e) {
      }
    },
    hideAction() {
      this.isActionShown = false;
      this.isListShown = true;
      this.loadClientActions();
    },
  },
};
</script>
<style lang="scss">
    .modal {
        form {
            min-height: 238px;
        }
        .btn.btn-arrow {
            min-width: 140px;
        }
        .btn-outline-secondary + .btn-arrow {
            margin: auto;
            margin-right: 0;
        }
    }
    .clientActionList {
        border-bottom: 1px solid $border-color;
        border-left: 1px solid $border-color;
        border-right: 1px solid $border-color;
    }
    .clientActionList:hover {
        cursor: pointer;
        background-color: $grey-light;
    }

    .clientActionList span {
        color: #000;
    }
    li {
        cursor: pointer;
    }
    .listIcon {
        background-color: $white;
    }
    .clientActionListItem {
        .header {
            background-color: $grey-light;
        }
        .body {
            background-color: $white;
        }
        .icon {
            visibility: hidden;
        }
    }
    .clientActionListItem:hover {
        .header {
            background-color: $teal-lightest;
        }
        .body {
            background-color: $grey-light;
        }
        .icon {
            visibility: visible;
        }
    }
</style>
